export const getSubjectName = ({ lessonDetailsReducer: { data } }) => data?.data?.subject?.name;
